<NiFormModal
    [isOpen]="isOpen"
    [title]="''"
    [hasBackdrop]="true"
    [preventBackdropClose]="true"
    (onClose)="closed.emit()"
    [showCancelIcon]="true"
    [className]="'max-w-[90%] sm:max-w-[520px] w-full rounded-[16px] border border-[#1018281F] bg-white shadow-lg'"
    >
    <div class="bg-white p-[20px] sm:p-[28px] font-archivo rounded-[16px]">
        <div class="flex flex-row items-center justify-between w-full mb-5">
        <span class="flex-1"></span>
        <h2 class="text-[#111215] text-[20px] font-bold leading-[32px] text-center flex-1">Log In</h2>
        <div class="flex-1 flex justify-end">
            <button
            type="button"
            class="text-[#444955] hover:text-[#111215] p-1 rounded transition-colors"
            aria-label="Close"
            (click)="closed.emit()"
            (keydown.enter)="closed.emit()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" [attr.stroke-width]="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
        </div>
    </div>

        <div class="text-[#444955] text-[16px] leading-[24px] mb-4 text-center">
        {{ step === 'email' ? 'Enter your registered email to receive a secure One-Time Password (OTP) for Log In.' : 'A One-Time Password (OTP) has been sent to your registered email.' }}
        </div>

        <div class="flex flex-col gap-4">
        <div *ngIf="step === 'email'" class="flex flex-col gap-3" (keydown.enter)="onEmailEnterKey($event)">
            <NiFormTextField
                label="Email Address"
                [placeholder]="'Enter Registered Email'"
                [showError]="!!emailError"
                [required]="true"
                [error]="emailError"
                [(ngModel)]="email"
                name="email"
            ></NiFormTextField>

            <div class="w-full">
            <NiFormButton
                label="Get OTP"
                color="primary"
                variant="contained"
                [fontSize]="18"
                [fontWeight]="700"
                paddingSize="px24_py_14"
                [fullWidth]="true"
                [loading]="isOtpLoading"
                [disabled]="isOtpLoading || !email"
                [styleClass]="'w-full rounded-lg'"
                (onClick)="requestOtp()"
            ></NiFormButton>
            </div>
        </div>

        <div *ngIf="step === 'otp'" class="flex flex-col gap-3" (keydown.enter)="onOtpEnterKey($event)">
            <div class="rounded-lg border border-gray-500 bg-gray-50 px-4 py-3 text-[#444955] text-[16px] break-all">
            {{ email }}
            </div>

            <NiFormOtp
            [label]="'Enter OTP'"
            [value]="otp"
            (valueChange)="onOtpChanged($event)"
            (keydown.enter)="onOtpEnterKey($event)"
            [showError]="!!otpError"
            [errorMessage]="otpError"
            ></NiFormOtp>

            <div class="flex items-center justify-between text-[14px] text-[#444955]">
            <button
                type="button"
                class="text-[#00ABC8] font-semibold"
                (click)="editEmail()"
            >
                Change email
            </button>
            <div *ngIf="isOtpLoading" class="ml-auto">Sending OTP...</div>
            <div *ngIf="!isOtpLoading && !showResend">Resend available in {{ timer }}s</div>
            <button
                *ngIf="!isOtpLoading && showResend"
                type="button"
                class="text-[#00ABC8] font-semibold"
                (click)="resendOtp()"
            >
                Resend OTP
            </button>
            </div>

            <div class="flex justify-end gap-3">
            <NiFormButton
                label="Cancel"
                variant="outlined"
                color="secondary"
                [fontWeight]="700"
                [fontSize]="18"
                paddingSize="px24_py_14"
                [styleClass]="'rounded-lg'"
                (onClick)="closed.emit()"
            ></NiFormButton>
            <NiFormButton
                label="Log In"
                variant="contained"
                color="primary"
                [fontWeight]="700"
                [fontSize]="18"
                paddingSize="px24_py_14"
                [loading]="isLoginLoading"
                [disabled]="isLoginLoading || isOtpLoading || !tempToken"
                [styleClass]="'rounded-lg'"
                (onClick)="submitLogin()"
            ></NiFormButton>
            </div>
        </div>
        </div>
    </div>

    <NiFormToaster
        *ngIf="showToaster"
        [message]="toasterMessage"
        [type]="toasterType"
        [position]="'bottom-center'"
        (onClose)="closeToaster()"
    ></NiFormToaster>
</NiFormModal>